import OnboardingLayoutScrollableContent from './OnboardingLayoutScrollableContent';

export default OnboardingLayoutScrollableContent;
